import mutations from './mutations';
import actions from './actions';

const state = {
  currentSectionId: 'selectDomain',
  currentModuleId: 'selectDomain',
  isCurrentModuleInvalid: false,
  isOpenConnectDomainDrawer: false,
  isCreateEmailSignatureLoading: false,
  isVerifyEmailSignatureLoading: false,
  isFetchVanityEmailDomainsLoading: false,
  isRetrieveVanityEmailDomainsLoading: false,
  vanityEmailDomains: [],
  vanityEmailDomain: null,
  isVerificationPending: false,
  isDeleteEmailSignatureLoading: false,
  isVerifyButtonClicked: false
};

export default {
  actions,
  mutations,
  state,
  getters: {},
  namespaced: true
};
